import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['image']

  connect() {
    const mask = this.element
    const img = this.imageTarget

    this.updateLens = () => {
      const maskH = mask.offsetHeight
      const imgH = img.offsetHeight
      const maxMove = Math.max((imgH - maskH) / 2, 0)

      const rect = mask.getBoundingClientRect()
      const winH = window.innerHeight
      const center = rect.top + rect.height / 2
      const rate = (center - winH / 2) / (winH / 2)

      const moveY = Math.max(Math.min(rate * maxMove * 0.8, maxMove), -maxMove)

      img.style.transform = `translate(-50%, calc(-50% + ${moveY}px))`
    }

    this.resizeAndUpdate = () => {
      const maskW = mask.offsetWidth
      const maskH = mask.offsetHeight
      const naturalW = img.naturalWidth
      const naturalH = img.naturalHeight

      const scale = 1.1
      const targetW = maskW * scale
      const targetH = maskH * scale

      const maskRatio = maskW / maskH
      const imgRatio = naturalW / naturalH
      let width, height
      if (imgRatio > maskRatio) {
        height = targetH
        width = height * imgRatio
      } else {
        width = targetW
        height = width / imgRatio
      }

      img.style.width = `${width}px`
      img.style.height = `${height}px`
      this.updateLens()
    }

    if (img.complete) {
      this.resizeAndUpdate()
    } else {
      img.addEventListener('load', this.resizeAndUpdate)
    }
    window.addEventListener('resize', this.resizeAndUpdate)
    window.addEventListener('scroll', this.updateLens)
  }

  disconnect() {
    if (this.hasImageTarget) {
      this.imageTarget.removeEventListener('load', this.resizeAndUpdate)
    }
    window.removeEventListener('resize', this.resizeAndUpdate)
    window.removeEventListener('scroll', this.updateLens)
  }
}
